import { c as _c } from "react/compiler-runtime";
import type { PresenceStatus } from '@sbt-web/network/types';
import { trackLinkClick } from '../utils/tracking/trackLinkClick';
import { PrivateUserBadgeSize, UserBadge } from './components/UserBadge';
const getProfileUrl = (userId: string): string => `/utente/${userId}`;
export interface PrivateUserAvatarProps {
  userId: string;
  name: string;
  pulseEventName: string;
  size?: PrivateUserBadgeSize;
  profileUrl?: string;
  picture?: string;
  presenceStatus?: PresenceStatus;
}
export const PrivateUserAvatar = t0 => {
  const $ = _c(13);
  const {
    userId,
    name,
    profileUrl,
    picture,
    size,
    presenceStatus,
    pulseEventName
  } = t0;
  let t1;
  if ($[0] !== profileUrl || $[1] !== userId) {
    t1 = profileUrl ?? getProfileUrl(userId);
    $[0] = profileUrl;
    $[1] = userId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== pulseEventName || $[4] !== userId) {
    t2 = () => trackLinkClick(userId, pulseEventName);
    $[3] = pulseEventName;
    $[4] = userId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const t3 = size === PrivateUserBadgeSize.Small ? presenceStatus : undefined;
  let t4;
  if ($[6] !== name || $[7] !== picture || $[8] !== size || $[9] !== t1 || $[10] !== t2 || $[11] !== t3) {
    t4 = <UserBadge name={name} url={t1} size={size} handleClick={t2} picture={picture} presenceStatus={t3} />;
    $[6] = name;
    $[7] = picture;
    $[8] = size;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};